import React from "react"
import { Container } from "reactstrap"



export const DepartmentDetails = (props) => {


  return <React.Fragment>
    <div className="page-content">
      <Container fluid>
        <h1>Departments Details</h1>
      </Container>
    </div>
  </React.Fragment>

}
